export default "__VITE_ASSET__iU2R8xbB__"